<template>
    <div class="detail">
        <!-- 数据展示栏 -->
        <div class="sj">
            <div class="sj_sp" @click="getCoupon">
                <span>领取总数：{{Total}}</span>
            </div>
            <div class="sj_sp">
                  <span>领取人数：{{lTotal}}</span>
            </div>
            <div class="sj_sp" @click="filteY">
                  <span>已使用：{{ylq}}</span>
            </div>
            <div class="sj_sp" @click="filteW">
                  <span>未使用：{{lTotal-ylq}}</span>
            </div>
        </div>

        <div class="table">
            <el-table
    :data="tableData"
    border
    style="width: 100%">
    <el-table-column
      prop="start"
      label="领取日期"
      width="150">
    </el-table-column>
    <el-table-column
      prop="userid"
      label="证件号码"
      width="180">
    </el-table-column>
    <el-table-column
      prop="title"
      label="券名称"
      width="250">
    </el-table-column>
     <el-table-column
      prop="money"
      label="优惠券金额"
      width="100">
    </el-table-column>
     <el-table-column
      prop="condition"
      label="使用条件满可用"
      width="120">
    </el-table-column>
     <el-table-column
      prop="tips"
      label="使用说明"
      width="250">
    </el-table-column>
    <el-table-column
      prop="start"
      label="开始日期"
      width="130">
    </el-table-column>
    <el-table-column
      prop="end"
      label="到期日期"
      width="130">
    </el-table-column>
     <el-table-column
      prop="state"
      label="使用状态"
      >
      <template slot-scope="scope">
                {{ scope.row.state==true?'已使用':'未使用' }}
              </template>
    </el-table-column>
     <el-table-column
      fixed="right"
      label="操作">
      <template slot-scope="scope">
        <el-button @click="delClick(scope.row._id)" type="text" size="small">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
        </div>
        
    </div>
</template>
<script>
export default {
    name:'detail',
    data(){
        return{
           tableData:[],
           ACCESS_TOKEN:"",
           Total:0,
           lTotal:0,
           ylq:0
        }
    },
    methods:{
        getCoupon(){
        this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("coupons").where({}).limit(1000).get()`,
        }).then(res=>{
          if(res.data.errcode !== 0){
            return this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
             res.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
            this.tableData = res.data.data

            //领取总数
            this.Total = res.data.pager.Total

            // 领取人数
            this.lTotal = Math.floor(res.data.pager.Total / 4)

            //已使用人数
            let arr = res.data.data.filter(item=>{
               return item.state == true
            })
            this.ylq = arr.length
            
            
         
             })
        },
    delClick(e){
        this.axios
        .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("coupons").doc("${e}").remove()`,
        }).then(rd=>{
            if(rd.data.errcode==0){
                  this.$message({
                  message: '删除成功',
                  type: 'success'
                });

                setTimeout(() => {
              this.$router.go(0);
            }, 1500);
            }
        })
    },
    //筛选已使用的券
    filteY(){
       this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("coupons").where({}).limit(1000).get()`,
        }).then(res=>{
             res.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });

       this.tableData =  res.data.data.filter(ite=>{
            return ite.state == true
        })

        })
    },
    filteW(){
       this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("coupons").where({}).limit(1000).get()`,
        }).then(rew=>{
             rew.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });

        this.tableData = rew.data.data.filter(ite=>{
            return ite.state == false
        })

        })

      
    },
  
    },
    created(){
        //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()
      
    },
    mounted(){
      setTimeout(()=>{
        this.getCoupon()
      },800)
        
    }

}
</script>
<style scoped>
.detail{
    margin-top: 15px;
  width: 100%;
  /* height: 850px; */
  background-color: #ffffff;
  border-radius: 7px;   
}
.sj{
    margin: 15px 0;
    width: 100%;
    height: 100px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}
.table{
    margin-top: 15px;
}
.sj_sp{
    width: 190px;
    height: 70px;
    background-color: #409EFF;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.sj_sp span{
    font-size: 20px;
    font-weight: bolder;
    color: #ffffff;
}
</style>